import React, { useEffect, useState } from 'react';
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  message,
  Modal,
  Popover,
  Row,
  Select,
  Switch,
  Typography,
  Space,
  Table,
} from 'antd';
import {
  CreateIndexFund,
  createIndexFund,
  createUnderlyingAsset,
  GROUP_ASSET_NAME,
  instrumentTypes,
  marketHours,
  RefreshAssetEod,
  refreshAssetEodFromRefinitiv,
  RefreshIndexFund,
  refreshIndexFundDataFromRefinitiv,
  REGIONS,
  selectors,
  UnderlyingAsset,
} from 'state';
import { useDispatch, useSelector } from 'react-redux';
import { InfoCircleOutlined } from '@ant-design/icons';
import { API_URL } from 'settings';
import type { TableColumnGroupType as ColumnGroupType, TableColumnType as ColumnType } from 'antd';
import type { TableColumnsType as ColumnsType } from 'antd';
import { formatters } from 'services';
import AssetGroupAllocations from '../SessionSettings/AssetGroupAllocations';

type Props = {
  hide: () => void;
};

type PlayerAndAllocs = {
  id: string;
  name: string;
  strategic_group_allocations: {
    [assetGroupId: string]: {
      lower_limit: number;
      upper_limit: number;
    };
  };
};

interface TableRowData {
  assetGroup: number | string;
  playerAllocations: {
    [playerId: string]: {
      lower_limit: number;
      upper_limit: number;
    };
  };
}

const CheckSAAdecisions: React.FC<Props> = ({ hide }) => {
  const dispatch = useDispatch();
  const players = useSelector(selectors.playersList);
  const computedWidth = players.length * 150 + 120;
  const modalWidth = Math.min(computedWidth, 1500);

  const columns: ColumnsType<TableRowData> = [
    {
      title: 'Asset Group',
      dataIndex: 'assetGroup',
      fixed: 'left',
      width: 120,
    },
    ...players.map(player => ({
      title: player.name,
      children: [
        {
          title: 'Lower',
          dataIndex: ['playerAllocations', player.id, 'lower_limit'],
          render: (value: number) => formatters.percent0Digits(value),
        },
        {
          title: 'Upper',
          dataIndex: ['playerAllocations', player.id, 'upper_limit'],
          render: (value: number) => formatters.percent0Digits(value),
        },
      ],
    })),
  ];

  const dataSource = players[0].strategic_group_allocations.map(allocation => {
    const assetGroupId = allocation.asset_group;

    const playerAllocations = players.reduce((acc, player) => {
      // Find the allocation for the current asset group
      const alloc = player.strategic_group_allocations.find(
        a => a.asset_group === assetGroupId
      );
      acc[player.id] = alloc
        ? { lower_limit: alloc.lower_limit, upper_limit: alloc.upper_limit }
        : { lower_limit: 0, upper_limit: 0 };
      return acc;
    }, {} as { [playerId: number]: { lower_limit: number; upper_limit: number } });

    return {
      assetGroup: GROUP_ASSET_NAME[assetGroupId],
      playerAllocations,
    };
  });

  return (
    <Modal
      open={true}
      // onOk={form.submit}
      onCancel={hide}
      title={'Players SAA decisions'}
      // footer={[{}]}
      width={modalWidth + 100}
      footer={null}
    >
      <Typography.Title level={4} style={{ display: 'inline-block' }}>
        Players SAA decisions
      </Typography.Title>
      <Table
        rowKey="assetGroup"
        dataSource={dataSource}
        columns={columns}
        // locale={noDataBehaviour}
        pagination={false}
        bordered
        scroll={{ x: computedWidth }}
        // footer={footer}
      />
      <br />
      {/*<Typography.Title level={2}>Bank Mandate</Typography.Title>*/}
      <div style={{ width: 350 }}>
        <AssetGroupAllocations />
      </div>
    </Modal>
  );
};
export default CheckSAAdecisions;
